import React, { FC } from 'react'
import useOnclickOutside from 'react-cool-onclickoutside'
import emojiToImg from '~/utils/emojiToImg'
import { hasAncestor } from '~/utils/DOM'

type EmojiPickerProps = {
  handleEmojiSelect: (emoji: string) => void
  active: boolean
  hide: () => void
  triggerRef: React.RefObject<HTMLButtonElement>
}

const emojis = ['🙂', '😀', '🙁', '❤️', '👍', '👋']

let EmojiPicker: FC<EmojiPickerProps> = ({
  handleEmojiSelect,
  triggerRef,
  active,
  hide,
}) => {
  const ref = useOnclickOutside(e => {
    if (!active) {
      return
    }

    if (!hasAncestor(e.target as HTMLElement, triggerRef.current!)) {
      hide()
    }
  })

  if (!active) {
    return null
  }

  return (
    <div className="chat-input-emoji" ref={ref}>
      {emojis.map(emoji => (
        <button
          onClick={() => {
            handleEmojiSelect(emoji)
            hide()
          }}
          dangerouslySetInnerHTML={{ __html: emojiToImg(emoji) }}
          key={emoji}
        />
      ))}
    </div>
  )
}

export default EmojiPicker
